/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/address';
import '../common/script';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "address": {
        "nested": {
          "format": {
            "nested": {
              "FormatAddressRequest": {
                "fields": {
                  "address": {
                    "type": ".squareup.common.address.Address",
                    "id": 1,
                    "rule": "optional"
                  },
                  "script": {
                    "type": ".squareup.common.script.Script",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deviceProperties": {
                    "type": ".squareup.address.format.DeviceProperties",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FormatAddressResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.address.format.FormatAddressResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.address.Address",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lines": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Error": {
                    "values": {
                      "OFFLINE": 1,
                      "NOT_FOUND": 2
                    }
                  }
                }
              },
              "DeviceProperties": {
                "fields": {
                  "maxWidth": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.address?.nested?.format?.nested?.FormatAddressRequest && !$root.nested?.squareup?.nested?.address?.nested?.format?.nested?.FormatAddressResponse && !$root.nested?.squareup?.nested?.address?.nested?.format?.nested?.FormatAddressResponse?.nested?.Error && !$root.nested?.squareup?.nested?.address?.nested?.format?.nested?.DeviceProperties) {
  $root.addJSON(jsonData);
}

/**
 * This is separate so these protos can be used in an offline library as well as via RPC
 *
 * SOURCE FormatAddressRequest @ squareup/address/format.proto at 14:1
 */
export const FormatAddressRequest = $root.lookupType('squareup.address.format.FormatAddressRequest');
fixType(FormatAddressRequest);
Builder.createAndAttachToType(FormatAddressRequest);
/**
 * SOURCE FormatAddressResponse @ squareup/address/format.proto at 29:1
 */
export const FormatAddressResponse = $root.lookupType('squareup.address.format.FormatAddressResponse');
fixType(FormatAddressResponse);
Builder.createAndAttachToType(FormatAddressResponse);
/**
 * SOURCE Error @ squareup/address/format.proto at 42:3
 */
FormatAddressResponse.Error = $root.lookupEnum('squareup.address.format.FormatAddressResponse.Error').values;
/**
 * SOURCE DeviceProperties @ squareup/address/format.proto at 52:1
 */
export const DeviceProperties = $root.lookupType('squareup.address.format.DeviceProperties');
fixType(DeviceProperties);
Builder.createAndAttachToType(DeviceProperties);